import { DisputeAlertAutomationSettings } from "@redotech/redo-dispute-settings-common/dispute-alert-filter";
import * as z from "zod";

// Per-network auto-refund rules wire contract. Reuses the model's
// DisputeAlertAutomationSettings — the single source of truth for the filter
// shape (the read path, the decision engine, and the write validator all narrow
// against it) — so the RPC wire never drifts from them. Deep business rules zod
// can't express (non-negative amount, 6–8-digit BIN, duplicate filters within a
// group) still run in the handler via validateAlertAutomationSettings() before
// persisting.
export const updateDisputeAlertAutomation = {
  name: "updateDisputeAlertAutomation" as const,
  input: z.object({ rules: DisputeAlertAutomationSettings }),
  output: z.object({
    success: z.boolean(),
    // Validation errors from validateAlertAutomationSettings, when not saved.
    errors: z.array(z.string()).optional(),
  }),
};
